import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  EMPTY_FUNCTION,
  EMPTY_FUNCTION_ASYNC,
  EMPTY_LIST,
  NOTIFICATION_TYPE,
} from '../../../../constants/common'
import { SINGLE_EMAIL_ENTITY } from '../../../../constants/entity'
import { useSelection } from '../../../../hooks'
import {
  EMAIL_TABLE_ROW_ACTIONS_CONFIG,
  EmailTableLayout,
} from '../../../Email'
import {
  ENTITY_TAB_EMAILS_ACTION,
  getEntityTabEmailsItemActions,
  useEntityTabEmailsActions,
} from '../../../EntityTab'
import { NotificationInline } from '../../../Notification'
import { PageEmptyState } from '../../../PageEmptyState'
import { TablePagination } from '../../../TablePagination'
import { Container } from '../../Container'

import {
  EMAIL_ARCHIVE_MOCK_ITEMS,
  EMAIL_ARCHIVE_MOCK_VISIBLE_COLUMNS,
} from './ProfileEmailsTabInhabitant.mocks'

import EmailIcon from '../../../../icons/email.svg'

const MOCK_PAGE_SIZE = 20

function useEmailArchiveMockTablePage() {
  const pageScrollWrapperRef = useRef(null)

  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(MOCK_PAGE_SIZE)
  const [columns, setColumns] = useState(EMAIL_ARCHIVE_MOCK_VISIBLE_COLUMNS)
  const [isConfigOpen, setConfigOpen] = useState(false)

  const count = EMAIL_ARCHIVE_MOCK_ITEMS.length
  const pageCount = Math.max(1, Math.ceil(count / pageSize))
  const items = {
    items: EMAIL_ARCHIVE_MOCK_ITEMS.slice(
      (page - 1) * pageSize,
      page * pageSize
    ),
  }
  const pagination = { count, page, pageCount, pageSize }

  const selection = useSelection({
    config: EMAIL_TABLE_ROW_ACTIONS_CONFIG,
    data: items,
    pagination,
  })

  function handleSetPagination(next) {
    setPage(next.page)
  }

  function handleSetSize(size) {
    setPageSize(size)
    setPage(1)
  }

  function handleConfigOpen() {
    setConfigOpen(true)
  }

  return {
    ...selection,
    columns,
    entity: SINGLE_EMAIL_ENTITY,
    handleApply: EMPTY_FUNCTION,
    handleConfigOpen,
    handleSetColumns: setColumns,
    handleSetPagination,
    handleSetSize,
    isConfigOpen,
    isLoading: false,
    items,
    pageScrollWrapperRef,
    pagination,
    refreshButtonProps: { onClick: EMPTY_FUNCTION },
    requiredColumns: EMPTY_LIST,
    setConfigOpen,
  }
}

function ProfileEmailsTabInhabitant() {
  const { t } = useTranslation()

  const [modal, setModal] = useState(null)

  function handleCloseModal() {
    setModal(null)
  }

  const tablePage = useEmailArchiveMockTablePage()

  const { setItemAction } = useEntityTabEmailsActions({
    onCloseModal: handleCloseModal,
    onReload: EMPTY_FUNCTION_ASYNC,
    onSetModal: setModal,
  })

  function handleRowClick(uuid) {
    setItemAction(ENTITY_TAB_EMAILS_ACTION.OpenInNewTab, { uuid })
  }

  return (
    <Container label='Email copies tab — mock data'>
      <NotificationInline
        text={t('EntityTabEmails.CopiesNoticeKey')}
        type={NOTIFICATION_TYPE.info}
      />
      <EmailTableLayout
        hasTable
        emptyState={
          <PageEmptyState
            EntityIcon={EmailIcon}
            text={t('EntityTabEmails.NoDataKey')}
          />
        }
        getItemActions={getEntityTabEmailsItemActions}
        modal={modal}
        rowExtraProps={{ onClick: handleRowClick }}
        setItemAction={setItemAction}
        tablePage={tablePage}
        withRowActions={false}
      />
      <TablePagination
        responsive
        value={tablePage.pagination}
        onChange={tablePage.handleSetPagination}
      />
    </Container>
  )
}

export default ProfileEmailsTabInhabitant
